<template>
    <div class="organizations">
        <Organizations/>
    </div>
</template>

<script>
import Organizations from '@/components/Organizations.vue'
export default {
    name: 'organizations',
    components: {
        Organizations
    }
}
</script>